import type { Location } from '@utils/types';
import type { ItineraryParams, ItineraryPathData } from '@utils/itinerary';

export enum LocationType {
    Hotel = 'hotel',
    City = 'city',
}

export interface HotelLocation extends Location<HotelLocation> {
    type: LocationType;
    englishTitle: string;
    cityTitle?: string;
}

export interface HotelPathData extends ItineraryPathData {
    city: string;
    hotelName: string;
    fromDate: string;
    toDate: string;
    room: string;
    roomCount: string;
    static?: string;
    stars?: string;
}

export interface HotelUrlParams extends ItineraryParams {
    url?: string;
    adultCount: number;
    childCount: number;
    infantCount?: number;
    cityName: string;
    hotelName: string;
    fromDate: string;
    toDate: string;
    roomCount?: number;
    static?: boolean;
}
